var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{attrs:{"dismissible":_vm.dismissible,"fade":_vm.fade,"show":_vm.show,"variant":_vm.color},on:{"dismissCountDown":function($event){return _vm.$emit('dismiss-count-down', $event)},"dismissed":function($event){return _vm.$emit('dismissed', $event)},"input":function($event){return _vm.$emit('input', $event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }